export default __webpack_public_path__ + "static/media/461.4498378c.jpg";